const customers = [
  { key: "phone", title: "phone", value: "phone" },
  { key: "status", title: "type", value: "status.title" },
  { key: "frindship", title: "familiarity_way", value: "frindship.title" },
  { key: "birthday", title: "birth", value: "birthday" },
  {
    key: "passed_cheque_amount",
    title: "passed_cheque_amount",
    value: "passed_cheque_amount",
  },
  { key: "city", title: "city", value: "city.text" },
];

const products = [
  { key: "category", title: "category", value: "category.title" },
];

const reminders = [
  { key: "date", title: "date", value: "date" },
  { key: "type", title: "type", value: "type.title" },
  { key: "customer", title: "customer", value: "customer.name" },
];

const notes = [{ key: "customer", title: "customer", value: "customer.name" }];

export default { customers, products, notes, reminders };

export interface RemindersFiltersT {
  date?: string;
  customer?: PickerItemT;
  type?: RadioButtonItemT;
}
